// Form messages
// =============

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import style from './error-message.scss'
import FieldSize, {
  fieldSizePropTypes,
  fieldSizeDefaultProps,
} from './fieldsize'

const ErrorMessage = ({ size, message, className, ariaLive }) => {
  return (
    <span
      className={cx(
        style.ErrorMessage,
        {
          [style.ErrorMessageDefault]: size === FieldSize.DEFAULT,
          [style.ErrorMessageSmall]: size === FieldSize.SMALL,
        },
        className
      )}
      aria-live={ariaLive}
    >
      {message}
    </span>
  )
}

ErrorMessage.defaultProps = {
  ...fieldSizeDefaultProps,
  ariaLive: 'polite',
}

ErrorMessage.propTypes = {
  ...fieldSizePropTypes,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
  ariaLive: PropTypes.oneOf(['off', 'polite', 'assertive']),
}

export default ErrorMessage
